import React, { useState, useEffect } from 'react';
import { Container, Table } from 'react-bootstrap';
import { findBoletinOficialVigente } from '@/api/municipalidadAPI';
import { listBoletinOficialVigenteOrdenanzaSitioWeb } from '@/api/municipalidadAPI';
import { listBoletinOficialVigenteDecretoSitioWeb } from '@/api/municipalidadAPI';
import { listDocumentoBoletinOficialSitioWeb } from '@/api/municipalidadAPI';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import { URL_ADJUNTOS } from '../constants/constants';
import './BoletinesView.css';

const BoletinesView = () => {
  const [vigente, setVigente] = useState(null);
  const [ordenanzas, setOrdenanzas] = useState(null);
  const [decretos, setDecretos] = useState(null);
  const [boletines, setBoletines] = useState(null);

  useEffect(() => {
    findBoletinOficialVigente()
      .then((response) => {
        setVigente(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    listBoletinOficialVigenteOrdenanzaSitioWeb('')
      .then((response) => {
        setOrdenanzas(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    listBoletinOficialVigenteDecretoSitioWeb('')
      .then((response) => {
        setDecretos(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    listDocumentoBoletinOficialSitioWeb()
      .then((response) => {
        setBoletines(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <MunicipalidadHeader tipo="Ciudadano" title="Boletín Vigente"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        {vigente !== null && (
          <div
            className="boletin-vigente"
            dangerouslySetInnerHTML={{ __html: vigente.legales }}
          ></div>
        )}
        <h5>Ordenanzas</h5>
        {ordenanzas !== null && (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Número</th>
                <th>Título</th>
                <th>Link</th>
              </tr>
            </thead>
            <tbody>
              {ordenanzas !== null &&
                ordenanzas.length > 0 &&
                ordenanzas.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.numero}</td>
                    <td>{item.titulo}</td>
                    <td>
                      <a href={item.link} rel="noreferrer" target="_blank">
                        {item.link}
                      </a>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}
        <h5>Decretos</h5>
        {decretos !== null && (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Número</th>
                <th>Descripción</th>
                <th>Area</th>
              </tr>
            </thead>
            <tbody>
              {decretos !== null &&
                decretos.length > 0 &&
                decretos.map((item, idx) => (
                  <tr key={idx}>
                    <td>{item.numero}</td>
                    <td>{item.descripcion}</td>
                    <td>{item.area}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}
        <h5>Licitaciones</h5>
        {vigente !== null && (
          <div
            className="boletin-vigente"
            dangerouslySetInnerHTML={{ __html: vigente.licitaciones }}
          ></div>
        )}
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Número</th>
              <th>Subido por</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            {boletines !== null &&
              boletines.length > 0 &&
              boletines.map((item, idx) => (
                <tr key={idx}>
                  <td>
                    <a
                      rel="noreferrer"
                      target="_blank"
                      href={URL_ADJUNTOS + '?id=' + item.documento.id}
                    >
                      {item.numeroBoletinOficial}{' '}
                      {item.mesAsString + ' ' + item.anioDocumentoAsString}
                    </a>
                  </td>
                  <td>{item.usuarioCreacion}</td>
                  <td>{item.fechaCreacion}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Container>
    </>
  );
};

export default React.memo(BoletinesView);
